// AirPlay support for hls.js playback in Safari.
//
// hls.js plays through ManagedMediaSource on Safari, and Safari only opens a
// ManagedMediaSource when the <video> either has remote playback disabled or also
// carries a plain HLS <source> that AirPlay can hand to the receiver instead. hls.js
// picks the first: on every attach it removes the <video>'s <source> children, adds
// its own blob <source>, and sets disableRemotePlayback, which removes AirPlay
// everywhere (our button, native fullscreen controls, Control Center).
//
// We take the second. Right after hls.js attaches, we append the playlist as an
// alternative <source> and turn remote playback back on. The local <video> keeps
// playing through hls.js (quality picker, thumbnails, etc. all still work), and when
// the viewer picks an AirPlay device, Safari sends the receiver the playlist URL.

import Hls from 'hls.js';

const HLS_MIME_TYPE = 'application/x-mpegURL';

// Safari is the only browser with both; elsewhere this is a no-op.
export function supportsAirPlay(win = window) {
  return !!(win.ManagedMediaSource && win.WebKitPlaybackTargetAvailabilityEvent);
}

export function addAirPlaySource(media, playlistUrl) {
  const source = media.ownerDocument.createElement('source');
  source.type = HLS_MIME_TYPE;
  source.src = playlistUrl;
  media.appendChild(source);
  media.disableRemotePlayback = false;
}

// An hls.js bufferController (see the `bufferController` config option) that adds the
// AirPlay source on every attach. hls.js runs MEDIA_ATTACHING listeners in the order
// they were registered, so ours runs right after the base controller has swapped in
// its blob <source> and called load(), while Safari is still waiting to pick a source.
// hlsjs-playback attaches before it loads the playlist, so the URL is passed in rather
// than read from hls.url.
export function airPlayBufferController(playlistUrl, Base = Hls.DefaultConfig.bufferController) {
  return class AirPlayBufferController extends Base {
    constructor(hls, ...rest) {
      super(hls, ...rest);
      hls.on(Hls.Events.MEDIA_ATTACHING, (event, data) => {
        addAirPlaySource(data.media, playlistUrl);
      });
    }
  };
}
